"use client";

import React from "react";
import Image from "next/image";
import styles from "./CityGridItem.module.scss";
import assetLoader from "@utils/internalImageLoder";
import { trackEventWithCommonProps, EventType } from "@utils/eventTracker";
import { getSelectedCityClient } from "@helpers/client/getSelectedCity";

interface CityGridItemProps {
  city: any;
  selectedCity?: any;
  onSelect: (city: any) => void;
  pageType?: string;
}

const CityGridItem = ({ city, selectedCity, onSelect, pageType }: CityGridItemProps) => {
  const isSelected = selectedCity?.id === city.id;

  const handleCitySelect = async () => {
    const currentSelectedCity = getSelectedCityClient();
    await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
      pageType: pageType,
      additionalProps: {
        action_type: "tap_btn",
        action_name: "tap_btn_city_selected",
        selected_city: city.name,
        city_name: currentSelectedCity?.name || "",
      },
    });

    onSelect(city);
  };

  return (
    <div
      onClick={handleCitySelect}
      className={isSelected ? styles.selected : styles.cityItemButton}
    >
      <div
        className={
          isSelected ? styles.selectedCityImageWrapper : styles.cityImageWrapper
        }
      >
        <Image
          src={
            city.city_config?.logo_image ||
            `${assetLoader()}/icons/city-placeholder.svg`
          }
          alt={city.name || "City"}
          fill
          className={styles.cityImage}
        />
      </div>
      <span className={styles.cityName}>{city.name}</span>
    </div>
  );
};

export default CityGridItem;
